import { render } from "./RecipientInfo.vue?vue&type=template&id=a07e7dce"
import script from "./RecipientInfo.vue?vue&type=script&lang=js"
export * from "./RecipientInfo.vue?vue&type=script&lang=js"

import exportComponent from "F:\\App-themes\\clickon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__